// Core Imports
import { api } from '@/core/lib/api'
import type { TResponse } from '@/core/types/axios'

// Module Imports
import { periodicGenerationEndpoints } from '@/modules/periodic-generation/periodic-generation.constants'
import type {
  TAvailableDraft,
  TCreatePeriodicRequest,
  TPeriodicGeneration,
  TUpdatePeriodicRequest,
} from '@/modules/periodic-generation/periodic-generation.types'

export async function getPeriodicList(
  page: number,
  query: string,
  status?: string
): Promise<TResponse<TPeriodicGeneration[]>> {
  const res = await api.get<TResponse<TPeriodicGeneration[]>>(
    periodicGenerationEndpoints.list(page, query, status)
  )
  return res.data
}

export async function getPeriodicDetail(
  id: string
): Promise<TPeriodicGeneration> {
  const res = await api.get<TResponse<TPeriodicGeneration>>(
    periodicGenerationEndpoints.detail(id)
  )
  return res.data.data
}

export async function getAvailableDrafts(
  includeId?: string
): Promise<TAvailableDraft[]> {
  const res = await api.get<TResponse<TAvailableDraft[]>>(
    periodicGenerationEndpoints.availableDrafts(includeId)
  )
  return res.data.data
}

export async function createPeriodic(
  body: TCreatePeriodicRequest
): Promise<TPeriodicGeneration> {
  const res = await api.post<TResponse<TPeriodicGeneration>>(
    periodicGenerationEndpoints.create,
    body
  )
  return res.data.data
}

export async function updatePeriodic(
  id: string,
  body: TUpdatePeriodicRequest
): Promise<TPeriodicGeneration> {
  const res = await api.patch<TResponse<TPeriodicGeneration>>(
    periodicGenerationEndpoints.update(id),
    body
  )
  return res.data.data
}

export async function activatePeriodic(id: string): Promise<void> {
  await api.post(periodicGenerationEndpoints.activate(id))
}

export async function passivePeriodic(id: string): Promise<void> {
  await api.post(periodicGenerationEndpoints.passive(id))
}

export async function deletePeriodic(id: string): Promise<void> {
  await api.delete(periodicGenerationEndpoints.remove(id))
}
